export default "__VITE_ASSET__6ce7308f__"